/**
 * Other Office Planting Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initOtherOfficePlanting() {
        const blocks = document.querySelectorAll('.other-office-planting');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] other-office-planting block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initOtherOfficePlanting);
    } else {
        initOtherOfficePlanting();
    }
})();